(() => {
  const dialog = document.getElementById('soa-letter');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const launcher = document.querySelector('.soa-letter-launch');
  const reviewsNav = document.querySelector('.soa-reviews-nav');
  if (launcher && reviewsNav && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => { launcher.hidden = entries.some(entry => entry.isIntersecting); }, {rootMargin:'0px 0px 90px 0px'}).observe(reviewsNav);
  }
  const key = 'soa-letter-dismissed-v8';
  const read = () => { try { return Number(localStorage.getItem(key) || 0); } catch { return Date.now(); } };
  const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch {} };
  let trigger;
  const open = (source) => { if (dialog.open) return; trigger = source || document.activeElement; dialog.showModal(); };
  const close = () => { dialog.close(); remember(); trigger?.focus?.(); };
  document.querySelectorAll('[data-soa-letter-open]').forEach(button => button.addEventListener('click', () => open(button)));
  dialog.querySelector('[data-soa-letter-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
  const sheet = dialog.querySelector('[data-soa-letter-sheet]');
  const intro = dialog.querySelector('[data-soa-letter-intro]');
  const reward = dialog.querySelector('#soa-letter-reward');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let startY = null, distance = 0, torn = false;
  const reveal = (animate = true) => {
    if (torn) return;
    torn = true;
    sheet.setAttribute('aria-expanded','true');
    const finish = () => {
      intro.hidden = true;
      reward.hidden = false;
      dialog.setAttribute('aria-labelledby','soa-letter-reward-heading');
      const title = reward.querySelector('[data-soa-letter-reward-title]');
      title.id = 'soa-letter-reward-heading';
      title.focus({preventScroll:true});
      dialog.scrollTop = 0;
      remember();
    };
    if (!animate || reduced.matches) { finish(); return; }
    sheet.classList.remove('is-dragging');
    sheet.classList.add('is-torn');
    setTimeout(finish,420);
  };
  sheet.addEventListener('pointerdown', event => {
    if (torn || event.button !== 0) return;
    startY = event.clientY;
    distance = 0;
    sheet.setPointerCapture(event.pointerId);
    sheet.classList.add('is-dragging');
    sheet.style.setProperty('--tear-progress','0%');
  });
  sheet.addEventListener('pointermove', event => {
    if (startY === null || torn) return;
    distance = Math.max(0,Math.min(240,event.clientY-startY));
    sheet.style.setProperty('--tear-progress', Math.min(100,distance/90*100) + '%');
    sheet.style.setProperty('--tear-y', distance + 'px');
    sheet.style.setProperty('--tear-rotate', Math.min(9,distance/18) + 'deg');
    sheet.style.setProperty('--tear-fold', Math.min(74,22+distance/3) + 'px');
  });
  const release = event => {
    if (startY === null || torn) return;
    startY = null;
    if (sheet.hasPointerCapture(event.pointerId)) sheet.releasePointerCapture(event.pointerId);
    sheet.classList.remove('is-dragging');
    if (event.type !== 'pointercancel' && distance >= 90) reveal();
    else { sheet.style.setProperty('--tear-progress','0%'); sheet.style.setProperty('--tear-y','0px'); sheet.style.setProperty('--tear-rotate','0deg'); sheet.style.setProperty('--tear-fold','22px'); }
  };
  sheet.addEventListener('pointerup',release);
  sheet.addEventListener('pointercancel',release);
  sheet.addEventListener('click',event => { if (event.detail === 0) reveal(); });
  if (dialog.querySelector('[data-soa-letter-success], [data-soa-letter-errors]')) { reveal(false); open(); dialog.querySelector('[role=status], [role=alert]')?.focus(); return; }
  if (document.body.classList.contains('page-type-collection') || document.body.classList.contains('page-type-search') || document.body.classList.contains('page-type-product') || document.body.classList.contains('page-type-cart') || location.pathname.includes('/challenge') || Date.now() - read() < 7 * 86400000 || window.Shopify?.designMode) return;
  let elapsed = false;
  const suggest = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    if (!elapsed || scrollY < max * .45 || document.querySelector('.offcanvas.show,.modal.show,dialog[open]')) return;
    open(); remember(); removeEventListener('scroll', suggest);
  };
  setTimeout(() => { elapsed = true; suggest(); }, 30000);
  addEventListener('scroll', suggest, { passive: true });
})();
